<template>

  <div id="loginbg">  ·
    <div id="yufu-image">
    </div>
    <div id="biaoti" ></div>
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
      <el-form-item prop="account">
        <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="卡号"></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input type="text" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"show-password>
        </el-input>
      </el-form-item>
      <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
      <el-link style="left: 210px;top: -3px" href="https://ahyfyx.com/#/login">手机登录</el-link>
      <el-form-item style="width:100%;">
        <el-button type="primary"  style="width:100%;" @click="cardLogin" :loading="logining">登录</el-button>
  <!--      <el-button type="primary" style="width:45%;" @click.native.prevent="register">公司入驻</el-button>-->
      </el-form-item>
    </el-form>
    <div id="all" ></div>
    <el-link id="beian" href="https://beian.miit.gov.cn/" target=‘_blank’  >
      <div>
        蜀ICP备18021345号-2
      </div>
    </el-link>
  </div>
</template>

<script>
  import { requestLogin } from '../../api/api';
  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入卡号', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          checkPass: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
          url: '../../assets/LOGO-800.png'
        },
        checked: false
      };
    },
    methods: {

      cardLogin(ev) {
        var _this = this;
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            //_this.$router.replace('/table');
            this.logining = true;
            //NProgress.start();
            var loginParams = {
                card: this.ruleForm2.account,
                cardPassword: this.ruleForm2.checkPass ,
            };
            //发起请求 http://localhost:1020/hrm/  auth/auth/oauth/token?
            this.$http.post("/card/selectUse",loginParams).then(res=>{
              var card1 = this.ruleForm2.account
                //获取到Token
                if(res.data.success){
                  if (res.data.data == "该提货卡已使用"){
                    this.$message.success(res.data.message);
                    this.$router.push({ path: '/userCardReservationOrder',query: {card:card1} });
                    this.logining = false;
                  }else {
                    //修改登录成功后跳转到首页
                    this.$message.success(res.data.message);
                    this.$router.push({ path: '/cardProduct',query: {card:card1} });
                    this.logining = false;
                  }
                }else{
                  this.$message.error(res.data.message);
                  this.logining = false;
                  return;
                }
            }).catch(error => {
                this.$message.error("登录失败["+error.message+"]");
                this.logining = false;
                return;
            });

          } else {
            //console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 75px auto;
    width: 350px;
    padding: 60px 50px 35px 45px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 20px 0px;
    }
  }
  #loginbg{
    background-image: url('../../assets/login.png');
    background-position: center;
    background-size:  100% 100%;background-repeat: no-repeat;
    height: 940px;
    //background-color: black;
  }
  #yufu-image{
    background-image: url('../../assets/yufu.png');
    background-position: center;
    //background-size:  80% 80%;
    background-repeat: no-repeat;
    height: 100px;
    margin-top:80px;
    //background-color: black;
  }
  #biaoti{
    background-position: center;
    //background-size:  10% 10%;
    background-repeat: no-repeat;
    //background-color: black;
  }
  #all{
    background-image: url('../../assets/all.png');
    background-position: center;
    background-repeat: no-repeat;
    height: 50px;
  }
  #beian{
    //display: block;
    left: 890px;
    text-align: center;
    margin-top: 140px;
  }
  /*#code{
    vertical-align:middle;
  }*/
</style>



// WEBPACK FOOTER //
// CardLogin.vue?41d21342